<template>
  <v-stepper :value="stepNumber" non-linear>
    <v-stepper-header v-if="!ice">
      <v-stepper-step step="1">{{ lang.stepper_header_1 }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2">{{ lang.stepper_header_2 }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">{{ lang.stepper_header_3 }}</v-stepper-step>
    </v-stepper-header>
    <v-stepper-header v-else>
      <v-stepper-step step="1">{{ lang.stepper_header_2 }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2">{{ lang.stepper_header_3 }}</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content :step="!ice ? 1 : 0" v-if="!ice">
        <connect-vc-share-comic-editor
          :lang="lang"
          :is-panel="isPanel"
          :is-firefox="isFirefox"
          :is-android-os="isAndroidOs"
          :is-ice="isIce"
        ></connect-vc-share-comic-editor>

        <v-btn
          color="primary"
          :class="$style.btnTextStyle"
          @click="
            step(stepNumber + 1);
            setImages();
            setContentsInfo();
          "
          v-bind:disabled="!enablePostStep1"
        >
          {{ lang.stepper_next }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-content :step="!ice ? 2 : 1">
        <connect-vc-share-comic-info-form
          :lang="lang"
          :is-panel="isPanel"
          :is-secure-view="isSecureView"
        ></connect-vc-share-comic-info-form>

        <vc-share-comic-cropper
          ref="cropper"
          v-show="false"
          :image-url="cropperImageUrl"
          :on-ready-cropper-callback="onReadyCropperCallback"
          :min-container-width="600"
          :min-container-height="600"
        ></vc-share-comic-cropper>

        <vc-share-comic-cropper
          ref="socialMediaImageCropper"
          v-show="false"
          :image-url="cropperSocialMediaImageUrl"
          :on-ready-cropper-callback="onReadySocialMediaImageCropperCallback"
          :aspect-ratio="2 / 1"
          :min-container-width="600"
          :min-container-height="600"
        ></vc-share-comic-cropper>

        <v-btn
          :class="[$style.btnTextStyle, 'ma-0']"
          flat
          @click="step(stepNumber - 1)"
          v-if="stepNumber > 1"
        >
          {{ lang.stepper_back }}
        </v-btn>

        <v-btn
          :class="[$style.btnTextStyle, 'ma-0']"
          color="primary"
          @click="step(stepNumber + 1)"
          v-bind:disabled="!enablePostStep2"
        >
          {{ lang.stepper_next }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-content :step="!ice ? 3 : 2">
        <template v-if="!isSecureView">
          <connect-vc-share-comic-meta-form
            :lang="lang"
            :rating-criteria-table-url="ratingCriteriaTableUrl"
            :locale="locale"
            :is-panel="isPanel"
            :is-client-enabled-circle-ms="isClientEnabledCircleMs"
            :circle-ms-url="circleMsUrl"
            :circle-ms-my-portal-url="circleMsMyPortalUrl"
          ></connect-vc-share-comic-meta-form>
        </template>
        <template v-else>
          <p class="mb-5">
            この作品は{{ secureViewClientName }}に連携されています。<br />
            <br />
            この作品を閲覧するためには{{
              secureViewClientName
            }}を利用する必要があります。
          </p>
        </template>

        <v-layout justify-center>
          <v-btn
            :class="[$style.btnTextStyle, 'ma-0']"
            color="primary"
            large
            @click="onPublish"
            :disabled="isBusy || !enablePostStep3"
            :loading="isBusy"
          >
            {{ lang.publish }}
          </v-btn>
        </v-layout>
        <v-btn flat :class="$style.btnTextStyle" @click="step(stepNumber - 1)">
          {{ lang.stepper_back }}
        </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import ice from "../../../lib/ice";
import comicSpine from "../../../lib/comicSpine";

export default {
  name: "vc-share-post-comic-stepper",
  data() {
    return {
      isPublishing: false,
      cropperImageUrl: "",
      cropperSocialMediaImageUrl: "",
      onReadyCropperCallback: () => {},
      onReadySocialMediaImageCropperCallback: () => {}
    };
  },
  props: {
    lang: {
      type: Object,
      default: () => ({
        stepper_header_1: "画像を入力",
        stepper_header_2: "タイトルを入力",
        stepper_header_3: "公開範囲を設定",
        stepper_next: "次へ",
        stepper_back: "戻る",
        publish: "公開する",
        beforeunload_message: "移動すると、編集内容は破棄されます。"
      })
    },
    ratingCriteriaTableUrl: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: ""
    },
    ice: {
      type: Boolean,
      default: false
    },
    initialDraftId: {
      type: Number,
      default: null
    },
    defaultThumbnailImageUrl: {
      type: String,
      default: ""
    },
    defaultSocialMediaImageUrl: {
      type: String,
      default: ""
    },
    initialDefaultSpineImageUrl: {
      type: String,
      default: ""
    },
    initialTitle: {
      type: String,
      default: ""
    },
    initialReaderType: {
      type: String,
      default: ""
    },
    initialIsDefaultHybrid3d: {
      type: Boolean,
      default: null
    },
    initialSize: {
      type: String,
      default: null
    },
    initialIceContentsPageCount: {
      type: Number,
      default: null
    },
    initialIceContentsHasCover: {
      type: Boolean,
      default: null
    },
    initialFrontCoverImageWidth: {
      type: Number,
      default: null
    },
    initialFrontCoverImageHeight: {
      type: Number,
      default: null
    },
    jwt: {
      type: String,
      default: ""
    },
    isSecureView: {
      type: Boolean,
      default: false
    },
    secureViewClientName: {
      type: String,
      default: ""
    },
    uploadPanel: {
      type: Boolean,
      default: false
    },
    isClientEnabledCircleMs: {
      type: Boolean,
      default: false
    },
    circleMsUrl: {
      type: String,
      default: ""
    },
    circleMsMyPortalUrl: {
      type: String,
      default: ""
    },
    isFirefox: {
      type: Boolean,
      default: false
    },
    isAndroidOs: {
      type: Boolean,
      default: false
    },
    isIce: {
      type: Boolean,
      default: false
    },

    //state
    draftId: {
      type: Number,
      default: null
    },
    pageProgressionDirection: {
      type: String,
      default: ""
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: function() {
        return [];
      }
    },
    defaultThumbnailOriginalImageUrl: {
      type: String,
      default: ""
    },
    defaultOriginalSocialMediaImageUrl: {
      type: String,
      default: ""
    },
    defaultFrontCoverImageUrl: {
      type: String,
      default: ""
    },
    userFrontCoverImageUrl: {
      type: String,
      default: ""
    },
    frontCoverType: {
      type: String,
      default: "simple"
    },
    backCoverType: {
      type: String,
      default: "simple"
    },
    spineCoverType: {
      type: String,
      default: "simple"
    },
    stepNumber: {
      type: Number,
      default: 1
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    defaultSpineImageUrl: {
      type: String,
      default: ""
    },

    //getters
    enablePostStep1: {
      type: Boolean,
      default: false
    },
    enablePostStep2: {
      type: Boolean,
      default: false
    },
    enablePostStep3: {
      type: Boolean,
      default: false
    },
    getNotIncludeCoverDataImageCount: {
      type: Number,
      default: 0
    },
    spineImageHeightMM: {
      type: Number,
      default: 0
    },
    spineImageWidthMM: {
      type: Number,
      default: 0
    },
    spineImageUrl: {
      type: String,
      default: ""
    },

    //actions
    postDraft: {
      type: Function,
      default: () => {}
    },
    putDraft: {
      type: Function,
      default: () => {}
    },
    publish: {
      type: Function,
      default: () => new Promise(() => {})
    },
    publishProgress: {
      type: Function,
      default: () => new Promise(() => {})
    },
    postDefaultThumbnailImage: {
      type: Function,
      default: () => {}
    },
    postDefaultSocialMediaImage: {
      type: Function,
      default: () => {}
    },
    getIceContentsInitialSettings: {
      type: Function,
      default: () => {}
    },
    updateHybrid3dSettings: {
      type: Function,
      default: () => {}
    },
    postDefaultSpineImage: {
      type: Function,
      default: () => {}
    },
    deleteDefaultSpineImage: {
      type: Function,
      default: () => {}
    },

    // mutations
    updatePageProgressionDirection: {
      type: Function,
      default: () => {}
    },
    setIsBusy: {
      type: Function,
      default: () => {}
    },
    updateDraftId: {
      type: Function,
      default: () => {}
    },
    updateJwt: {
      type: Function,
      default: () => {}
    },
    updateIsSecureView: {
      type: Function,
      default: () => {}
    },
    updateTitle: {
      type: Function,
      default: () => {}
    },
    updateIsDefaultHybrid3d: {
      type: Function,
      default: () => {}
    },
    updateDefaultThumbnailOriginalImageUrl: {
      type: Function,
      default: () => {}
    },
    updateDefaultOriginalSocialMediaImageUrl: {
      type: Function,
      default: () => {}
    },
    updateDefaultSpineImageUrl: {
      type: Function,
      default: () => {}
    },
    updateIsUploadIceContents: {
      type: Function,
      default: () => {}
    },
    updateSizeSelect: {
      type: Function,
      default: () => {}
    },
    updateSize: {
      type: Function,
      default: () => {}
    },
    updateIceContentsPageCount: {
      type: Function,
      default: () => {}
    },
    updateIceContentsHasCover: {
      type: Function,
      default: () => {}
    },
    updateFrontCoverType: {
      type: Function,
      default: () => {}
    },
    updateBackCoverType: {
      type: Function,
      default: () => {}
    },
    updateSpineCoverType: {
      type: Function,
      default: () => {}
    },
    updateFrontCoverImageWidth: {
      type: Function,
      default: () => {}
    },
    updateFrontCoverImageHeight: {
      type: Function,
      default: () => {}
    },
    updateStepNumber: {
      type: Function,
      default: () => {}
    },
    setIsPanel: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    this.setIsPanel(this.uploadPanel);
    this.updateJwt(this.jwt);
    if (this.isSecureView) {
      this.updateIsSecureView(this.isSecureView);
    }

    if (this.initialDraftId > 0) {
      this.updateDraftId(this.initialDraftId);
    } else {
      this.postDraft();
    }

    this.updateIsUploadIceContents(this.ice);
    if (this.initialIsDefaultHybrid3d !== null) {
      this.updateIsDefaultHybrid3d(this.initialIsDefaultHybrid3d);
    }
    if (ice.isIce() && this.ice) {
      this.getIceContentsInitialSettings().then(() => {
        this.putDraft();
      });
    }
    this.updateFrontCoverType(this.frontCoverType);
    this.updateBackCoverType(this.backCoverType);
    this.updateSpineCoverType(this.spineCoverType);

    if (this.defaultThumbnailImageUrl !== "") {
      setTimeout(() => {
        this.updateDefaultThumbnailOriginalImageUrl(
          this.defaultThumbnailImageUrl
        );

        this.cropperImageUrl = this.defaultThumbnailImageUrl;
        this.onReadyCropperCallback = (cropper, croppedCanvasToBlob) => {
          croppedCanvasToBlob().then(blob => {
            this.postDefaultThumbnailImage(blob);
          });
        };
      }, 500);
    }

    if (this.defaultSocialMediaImageUrl !== "") {
      setTimeout(() => {
        this.updateDefaultOriginalSocialMediaImageUrl(
          this.defaultSocialMediaImageUrl
        );

        this.cropperSocialMediaImageUrl = this.defaultSocialMediaImageUrl;
        this.onReadySocialMediaImageCropperCallback = (
          cropper,
          croppedCanvasToBlob
        ) => {
          croppedCanvasToBlob().then(blob => {
            this.postDefaultSocialMediaImage(blob);
          });
        };
      }, 3000);
    }

    if (this.initialTitle !== "") {
      this.updateTitle(this.initialTitle);
    }

    if (this.ice && this.initialReaderType === "vertical") {
      this.updatePageProgressionDirection("vertical");
    }

    if (this.initialDefaultSpineImageUrl !== "") {
      this.updateDefaultSpineImageUrl(this.initialDefaultSpineImageUrl);
    } else if (this.ice) {
      comicSpine.generateBlankSpineImage().then(blob => {
        this.postDefaultSpineImage(blob);
      });
    }

    if (this.initialSize) {
      this.updateSize(this.initialSize);
    }
    if (this.initialIceContentsPageCount !== null) {
      this.updateIceContentsPageCount(this.initialIceContentsPageCount);
    }
    if (this.initialIceContentsHasCover !== null) {
      this.updateIceContentsHasCover(this.initialIceContentsHasCover);
    }
    if (this.initialFrontCoverImageWidth !== null) {
      this.updateFrontCoverImageWidth(this.initialFrontCoverImageWidth);
    }
    if (this.initialFrontCoverImageHeight !== null) {
      this.updateFrontCoverImageHeight(this.initialFrontCoverImageHeight);
    }
    if (!ice.isIce()) {
      window.onbeforeunload = e => {
        e.returnValue = this.lang.beforeunload_message;
        return this.lang.beforeunload_message;
      };
    }
  },
  methods: {
    step(step) {
      this.updateStepNumber(step);
      this.$vuetify.goTo(0);
    },
    setImages() {
      this.setDefaultThumbnailImage();
      this.setDefaultSocialMediaImage();
      if (!this.isPanel) {
        this.setDefaultSpineImage();
      }
    },
    setDefaultThumbnailImage() {
      if (!this.defaultThumbnailOriginalImageUrl) {
        if (this.images.length > 0) {
          let image = {};
          if (this.frontCoverType === "simple") {
            image = this.images.find(
              img => img.imageId > 0 && img.isBlank === false && !img.notMove
            );
          } else {
            image.src = this.userFrontCoverImageUrl;
          }
          if (image) {
            this.updateDefaultThumbnailOriginalImageUrl(image.src);

            this.cropperImageUrl = image.src;
            this.onReadyCropperCallback = (cropper, croppedCanvasToBlob) => {
              croppedCanvasToBlob().then(blob => {
                this.postDefaultThumbnailImage(blob);
              });
            };
          }
        }
      }
    },
    setDefaultSocialMediaImage() {
      if (!this.defaultOriginalSocialMediaImageUrl) {
        if (this.images.length > 0) {
          let image = {};
          if (this.frontCoverType === "simple") {
            image = this.images.find(
              img => img.imageId > 0 && img.isBlank === false && !img.notMove
            );
          } else {
            image.src = this.userFrontCoverImageUrl;
          }
          if (image) {
            this.updateDefaultOriginalSocialMediaImageUrl(image.src);

            this.cropperSocialMediaImageUrl = image.src;
            this.onReadySocialMediaImageCropperCallback = (
              cropper,
              croppedCanvasToBlob
            ) => {
              croppedCanvasToBlob().then(blob => {
                this.postDefaultSocialMediaImage(blob);
              });
            };
          }
        }
      }
    },
    async setDefaultSpineImage() {
      if (
        this.frontCoverType === "user_upload" &&
        this.userFrontCoverImageUrl
      ) {
        const blob = await comicSpine.generateDefaultSpineImage(
          this.userFrontCoverImageUrl,
          this.pageProgressionDirection
        );
        await this.postDefaultSpineImage(blob);
      } else {
        if (this.defaultSpineImageUrl) {
          await this.deleteDefaultSpineImage();
        }
      }
    },
    setContentsInfo() {
      if (this.isPanel) {
        this.updateSizeSelect(this.$store.state.uploadContents.sizeSelect);
      }
    },
    async onPublish() {
      this.setIsBusy(true);
      const PUBLISH_PROGRESS_INTERVAL = 500;

      try {
        await this.putDraft();

        this.publish();

        const doProgress = () => {
          this.publishProgress().then(
            params => {
              if (!params) {
                return;
              }

              const status = params.status;
              const redirectUrl = params.redirectUrl;
              switch (status) {
                case "in_progress":
                default:
                  // プログレスバーの更新処理
                  setTimeout(doProgress, PUBLISH_PROGRESS_INTERVAL);
                  break;
                case "complete":
                  this.setIsBusy(false);
                  window.onbeforeunload = () => {};
                  window.location.href = redirectUrl;
                  break;
                case "error":
                  this.setIsBusy(false);
                  // TODO: エラー表示
                  break;
              }
            },
            () => {
              this.setIsBusy(false);
            }
          );
        };
        setTimeout(doProgress, PUBLISH_PROGRESS_INTERVAL);
      } catch (error) {
        this.setIsBusy(false);
      }
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
}
</style>
